import { RootState } from '../../rootReducer'

export const selectInvestorStatistics = (state: RootState) => state.statistics.investorStatistics

export const selectHabitatStatistics = (state: RootState) => state.statistics.habitatStatistics
